import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../services/translation.service';
import * as moment from 'moment';

/**
 * Add a duration to a value (like 10 days)
 */
@Pipe({
    name: 'duration'
})
export class DurationPipe implements PipeTransform {
    private units: any = {
        en: {d: 'd', h: 'h', m: 'm', s: 's'},
        es: {d: 'd', h: 'h', m: 'm', s: 's'},
        de: {d: 'T', h: 'h', m: 'm', s: 's'},
        fr: {d: 'j', h: 'h', m: 'm', s: 's'},
        nl: {d: 'd', h: 'u', m: 'm', s: 's'},
        it: {d: 'g', h: 'o', m: 'm', s: 's'}
    };
    private unitsExtend: any = {
        en: {d: 'day', ds: 'days', h: 'hour', hs: 'hours', m: 'min', s: 'sec'},
        es: {d: 'día', ds: 'días', h: 'hora', hs: 'horas', m: 'min', s: 'sec'},
        de: {d: 'Tag', ds: 'Tage', h: 'Stunde', hs: 'Stunden', m: 'min', s: 'Sek'},
        fr: {d: 'jour', ds: 'jours', h: 'heure', hs: 'heures', m: 'min', s: 'sec'},
        nl: {d: 'dag', ds: 'dagen', h: 'uur', hs: 'uren', m: 'min', s: 'sec'},
        it: {d: 'giorno', ds: 'giorni', h: 'ora', hs: 'orari', m: 'min', s: 'sec'}
    };
    private lang: string = 'en';

    constructor(private translationService: TranslationService) {}

    transform(duration: number, extend?: boolean): any {
        this.lang = this.translationService.getCurrentLang();

        return extend ? this.processDurationExtend(duration) : this.processDuration(duration);
    }

    private processDuration(duration: number): any {
        if (duration >= 86400) {
            return Math.floor(duration / 86400) + this.units[this.lang].d;
        } else if (duration >= 3600) {
            if (duration % 3600 === 0) {
                return moment.utc(duration * 1000).format('H[' + this.units[this.lang].h + ']');
            }
            return moment.utc(duration * 1000).format('H[' + this.units[this.lang].h + ']mm');
        } else if (duration >= 60) {
            return moment.utc(duration * 1000).format('m[' + this.units[this.lang].m + ']');
        } else {
            return moment.utc(duration * 1000).format('s[' + this.units[this.lang].s + ']');
        }
    }

    private processDurationExtend(duration: number): any {
        if (duration >= 86400) {
            const time = Math.floor(duration / 86400);

            return time + ' ' + (time > 1 ? this.unitsExtend[this.lang].ds : this.unitsExtend[this.lang].d);
        } else if (duration >= 3600) {
            const time = Math.floor(duration / 3600);
            const unit = (time > 1 ? this.unitsExtend[this.lang].hs : this.unitsExtend[this.lang].h);

            if (duration % 3600 === 0) {
                return moment.utc(duration * 1000).format('H[ ' + unit + ']');
            }
            return moment.utc(duration * 1000).format('H[ ' + unit + ' ]mm');
        } else if (duration >= 60) {
            return moment.utc(duration * 1000).format('m[ ' + this.unitsExtend[this.lang].m + ']');
        } else {
            return moment.utc(duration * 1000).format('s[ ' + this.unitsExtend[this.lang].s + ']');
        }
    }
}
